<template>
  <div>
    <b-loading is-full-page :active="loading.documents" can-cancel></b-loading>

    <section>
      <div class="columns">
        <div class="column has-text-right">
          <div v-if="crier || authority || agenteContratacao">
            <button
              v-if="displayStartBids"
              class="button field is-primary actions"
              :class="{ ' is-loading': loading.general }"
              :disabled="!selectedItems.length || bidItems"
              @click="startBids"
            >
              <span>Iniciar Lances</span>
            </button>

            <button
              v-if="verifySituation(SituacaoEnum.PREFERENCIA)"
              class="button field is-primary actions"
              :class="{ ' is-loading': loading.general }"
              :disabled="!selectedItems.length || bidItems"
              @click="startPreference"
            >
              <span>Iniciar Preferência</span>
            </button>

            <b-tooltip
              size="is-medium"
              position="is-left"
              :label="selectedNegotiationTooltip"
              :active="!!selectedNegotiationTooltip"
            >
              <button
                v-if="
                  verifySituation(SituacaoEnum.NEGOCIACAO) ||
                  verifySituation(SituacaoEnum.JULGAMENTO)
                "
                class="button field is-primary actions"
                :class="{ ' is-loading': loading.general }"
                :disabled="!canOpenBulkNegotiationModal"
                @click="openModal(filteredIds, 'negotiation')"
              >
                <span>Negociar Todos</span>
              </button>
            </b-tooltip>

            <button
              v-if="displayRequestDiligenceBulk"
              class="button field is-primary actions"
              :class="{ 'is-loading': loading.general }"
              :disabled="!selectedJudgmentItems.length"
              @click="openRequestDiligenceModal"
            >
              <span>Solicitar Diligência</span>
            </button>

            <button
              v-if="displayAdjudicateButton"
              class="button field is-primary actions"
              :class="{ 'is-loading': loading.adjudicarItens }"
              :disabled="!selectedItems.length"
              @click="adjudicarFornecedoresItens"
            >
              <span>Adjudicar</span>
            </button>

            <button
              v-if="displayHomologateButton"
              class="button field is-primary actions"
              :class="{ 'is-loading': loading.homologarItens }"
              :disabled="!selectedItems.length"
              @click="homologarFornecedoresItens"
            >
              <span>Homologar</span>
            </button>

            <button
              v-if="displayUndoButton"
              class="button field is-danger is-outlined actions"
              :class="{ 'is-loading': loading.general }"
              :disabled="!selectedItems.length"
              @click="openUndoConfirmation()"
            >
              <span>Desfazer</span>
            </button>
          </div>
        </div>
      </div>
    </section>

    <div v-if="!items.length" class="panel">
      <div class="panel-block is-justify-content-center">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>Nenhum item.</p>
          </div>
        </section>
      </div>
    </div>

    <b-table
      hoverable
      scrollable
      class="table is-fullwidth auction-items-table"
      v-if="items.length"
      detail-key="id"
      :detailed="displayQualificationAnalysis"
      :opened-detailed.sync="qualificationDetailsList"
      :checked-rows.sync="selectedItems"
      :checkable="displayCheckable"
      :is-row-checkable="checkableItems"
      :data="itemsToShow"
    >
      <b-table-column centered label="Exclusivo" width="60" v-slot="props" :visible="exclusiveItem">
        <b-icon
          custom-size="mdi-24px"
          icon="check"
          type="is-success"
          v-show="props.row.item.exclusivo"
        />
      </b-table-column>

      <b-table-column centered label="ID" width="40" field="identificador" v-slot="props">{{
        props.row.identificador
      }}</b-table-column>

      <b-table-column
        centered
        field="unidade"
        label="Unidade"
        v-slot="props"
        :visible="displayItemMeasureColumns"
        ><div class="unity-column">{{ props.row.unidade.nome }}</div></b-table-column
      >

      <b-table-column
        cell-class="elipsis-size"
        label="Descrição"
        v-slot="props"
        :key="descriptionKey"
      >
        <div
          class="elipsis-column"
          :class="{
            'cursor-pointer': displayEyeIcon(props.row.id),
            'justify-align': justify,
          }"
          :ref="`description-container-${props.row.id}`"
          @click.stop.prevent="openDescription(props.row.id)"
        >
          <b-icon
            class="custom-eye-icon mr-1"
            icon="eye-outline"
            v-if="displayEyeIcon(props.row.id)"
          ></b-icon>

          <a
            v-if="displayEyeIcon(props.row.id)"
            :class="{ 'justify-align': justify }"
            :ref="`description-link-${props.row.id}`"
            >{{ props.row.item.descricao }}</a
          >
          <p v-else>{{ props.row.item.descricao }}</p>
        </div>
      </b-table-column>

      <b-table-column
        centered
        label="Quantidade"
        v-slot="props"
        :visible="displayItemMeasureColumns"
        >{{ props.row.quantidade | formatarNumero }}</b-table-column
      >

      <b-table-column centered label="Referência" v-slot="props" :visible="displayReferralColumn"
        ><div v-if="!props.row.referencia && !props.row.total">
          <b-tag type="is-dark" size="is-small">VIDE EDITAL</b-tag>
        </div>
        <div v-else>{{ formatReference(props.row) | formatarValor }}</div></b-table-column
      >

      <b-table-column centered label="Total" v-slot="props" :visible="displayTotalReferential">
        <div v-if="!props.row.referencia && !props.row.total">
          <b-tag type="is-dark" size="is-small">VIDE EDITAL</b-tag>
        </div>
        <div v-else>{{ displayTotalReferential ? formatarValor(props.row.total) : 0 }}</div>
      </b-table-column>

      <b-table-column centered label="Redução" v-slot="props" :visible="displayReductionColumn"
        ><b-tooltip
          v-if="biggestDiscount && props.row.referencia && props.row.total"
          size="is-medium"
          :label="formatarValor(props.row.reducaoLances)"
          >{{ formatPercentageReduction(props.row) }}</b-tooltip
        >

        <div v-else-if="biggestDiscount">
          {{ formatPercentageReduction(props.row) }}
        </div>

        <div v-else>
          {{ props.row.reducaoLances | formatarValor }}
        </div></b-table-column
      >

      <b-table-column
        centered
        class="lower-bid-column"
        v-slot="props"
        :visible="displayMinorBid"
        :label="biggestDiscount ? 'Maior Desconto' : 'Menor Lance'"
      >
        <div class="has-text-centered" :class="{ 'is-flex': mobile, 'justify-end': mobile }">
          <b-tooltip
            v-if="biggestDiscount && props.row.referencia && props.row.total"
            size="is-medium"
            class="discount-tooltip"
            :type="lowerBidColor(props.row)"
            :label="
              props.row.menor_lance.percentual !== null
                ? formatMinorBid(props.row)
                : 'Nenhum Fornecedor'
            "
          >
            <span
              v-if="displayMinorBidTag"
              class="tag tag-extended"
              :class="lowerBidColor(props.row)"
              >{{ formatDiscountPercentage(props.row) }}</span
            >
          </b-tooltip>

          <div v-else>
            <span
              v-if="displayMinorBidTag"
              class="tag tag-extended"
              :class="lowerBidColor(props.row)"
              >{{
                biggestDiscount
                  ? formatDiscountPercentage(props.row)
                  : formatarValor(minorBidExists(props.row))
              }}</span
            >
          </div>

          <b-tooltip
            v-if="biggestDiscount && props.row.referencia && props.row.total"
            size="is-medium"
            type="is-light"
            class="discount-tooltip"
            :label="
              props.row.preferencia.percentual !== null
                ? formatPreferenceBid(props.row)
                : 'Nenhum Fornecedor'
            "
          >
            <span
              v-if="displayPreference(props.row.preferencia.fornecedor)"
              class="tag small tag-extended"
              >{{ formatPreferenceDiscount(props.row) }}</span
            >
          </b-tooltip>

          <div v-else>
            <span
              v-if="displayPreference(props.row.preferencia.fornecedor)"
              class="tag small tag-extended"
              >{{
                biggestDiscount
                  ? formatPreferenceDiscount(props.row)
                  : formatarValor(preferenceValueExists(props.row))
              }}</span
            >
          </div>
        </div>
      </b-table-column>

      <b-table-column centered label="Fornecedor" v-slot="props" :visible="displayMinorBid">
        <div :class="{ 'is-flex': mobile, 'justify-end': mobile }">
          <span
            v-if="displayCompany && getFornecedorFormatado(props.row.menor_lance)"
            class="tag tag-extended"
            :class="lowerBidColor(props.row)"
            >{{
              getFornecedorFormatado(props.row.menor_lance) | formatarPadrao('Nenhum Fornecedor')
            }}</span
          >

          <span
            v-else-if="displayProviderTag"
            class="tag tag-extended"
            :class="lowerBidColor(props.row)"
            >{{ props.row.menor_lance.fornecedor | formatarPadrao('Nenhum Fornecedor') }}</span
          >

          <span
            class="tag tag-extended"
            v-if="displayPreference(props.row.preferencia.fornecedor)"
            >{{ preferenceBidExists(props.row) }}</span
          >
        </div>
      </b-table-column>

      <b-table-column centered label="Porte" v-slot="props" :visible="displaySizeColumn">
        <div class="has-text-centered" :class="{ 'is-flex': mobile, 'justify-end': mobile }">
          <div class="company-size-text mr-1">{{ formatWinnerCompanySize(props.row) }}</div>

          <div class="tag small" v-if="displayPreference(props.row.preferencia.fornecedor)">
            {{ preferenceSizeExists(props.row) }}
          </div>
        </div>
      </b-table-column>

      <b-table-column centered label="Estado" v-slot="props" :visible="displayStatusColumn">
        <span
          class="tag is-primary tag-extended"
          :class="props.row.estado | estadoItem(auction.modo_disputa)"
          >{{ getItemStatusLabel(props.row) }}</span
        >
      </b-table-column>

      <b-table-column
        centered
        label="Propostas"
        width="60"
        v-slot="props"
        :visible="
          [SituacaoEnum.ENTREGA_DE_PROPOSTAS, SituacaoEnum.AGUARDANDO_INICIO_SESSAO].indexOf(
            auctionSituation,
          ) > -1 && company.id === auction.comprador.id
        "
      >
        <div v-if="['REVOGADO', 'DESERTO'].indexOf(props.row.estado) === -1">
          {{ totalProposals(props.row.id) ? totalProposals(props.row.id) : 0 }}
        </div>
      </b-table-column>

      <b-table-column
        centered
        label="Adesões"
        v-slot="props"
        width="60"
        :visible="auctionSituation === 11 && company.id === auction.comprador.id"
      >
        {{ buyer && auctionSituation === 11 ? totalAdhesions(props.row.id) : 0 }}
      </b-table-column>

      <b-table-column
        centered
        class="actions-column"
        label="Ações"
        v-slot="props"
        :visible="displayActions"
      >
        <div class="is-flex justify-center has-text-centered" :class="{ 'justify-end': mobile }">
          <b-tooltip
            size="is-medium"
            position="is-left"
            :label="acceptButtonTooltip(props.row)"
            :active="disableAccept(props.row) || hasJudgmentDiligenceBlock(props.row)"
          >
            <button
              class="button is-primary mb-1"
              v-if="displayAcceptRefuse(props.row.estado, props.row)"
              :disabled="
                disable.accept || disableAccept(props.row) || hasJudgmentDiligenceBlock(props.row)
              "
              @click="
                openModal(
                  props.row.id,
                  'accept',
                  props.row.menor_lance ? props.row.menor_lance.fornecedor : '',
                )
              "
            >
              Aceitar
            </button>
          </b-tooltip>

          <b-tooltip
            size="is-medium"
            position="is-left"
            label="Aguardando análise dos documentos da diligência"
            :active="hasJudgmentDiligenceBlock(props.row)"
          >
            <button
              class="button is-danger ml-1"
              v-if="displayAcceptRefuse(props.row.estado, props.row)"
              :disabled="disable.refuse || hasJudgmentDiligenceBlock(props.row)"
              @click="
                openModal(
                  props.row.id,
                  'refuse',
                  props.row.menor_lance ? props.row.menor_lance.fornecedor : '',
                )
              "
            >
              {{ refuseButtonLabel }}
            </button>
          </b-tooltip>

          <button
            class="button is-primary ml-1"
            v-if="displayAcceptRefuse(props.row.estado, props.row) && props.row.item.tipo === 'LOT'"
            :disabled="disableAccept(props.row)"
            @click.prevent.stop="
              viewReadjustProposals(
                props.row,
                proposals.find(
                  p =>
                    p.oferta_compra_item_id === props.row.id &&
                    p.fornecedor_id === props.row.menor_lance.fornecedor_id,
                ),
              )
            "
          >
            Ver readequação
          </button>

          <button
            class="button is-primary ml-1 mb-1"
            v-if="displaySendDocuments(props.row.id, props.row.estado)"
            @click="sendDocuments(props.row)"
          >
            Enviar Documentos
          </button>

          <SelecionarEmpresaAdesao
            v-if="adheredPriceItem(props.row.id) && crier && props.row.estado === 'HABILITACAO'"
            :item="props.row"
            @selecionar-empresa="company => selectCompany(props.row, company)"
          />

          <button
            class="button is-primary is-outlined documents-button"
            v-if="displayViewDocuments(props.row) && !displayQualificationAnalysis"
            @click.prevent.stop="viewCompanyDocuments(props.row)"
          >
            Ver Documentos
          </button>

          <button
            class="button is-primary is-outlined documents-button ml-1"
            v-if="displayReviewJudgmentDiligence(props.row)"
            @click.prevent.stop="openJudgmentDiligenceReview(props.row)"
          >
            Visualizar Documentos
          </button>

          <button
            v-if="
              displayAdherenceButton(
                props.row.id,
                props.row.menor_lance.fornecedor_id,
                props.row.estado,
              )
            "
            class="button is-primary actions"
            :disabled="disable.adhere"
            @click.stop.prevent="
              mountAdhesionConfirmation(
                props.row.id,
                props.row.identificador,
                props.row.item.descricao,
                props.row.unidade.nome,
                true,
              )
            "
          >
            Aderir
          </button>

          <button
            v-if="
              displayAdherenceButton(
                props.row.id,
                props.row.menor_lance.fornecedor_id,
                props.row.estado,
              )
            "
            class="button is-danger actions"
            :disabled="disable.adhere"
            @click.stop.prevent="
              mountAdhesionConfirmation(
                props.row.id,
                props.row.identificador,
                props.row.item.descricao,
                props.row.unidade.nome,
                false,
              )
            "
          >
            Não Aderir
          </button>

          <div
            v-if="adheredPriceItem(props.row.id) && auctionSituation === 11 && bidder"
            class="tag is-primary tag-extended"
          >
            <h3 style="font-weight: bold">Aderido</h3>
          </div>

          <div
            v-if="abdicateAdhesionItem(props.row.id) && auctionSituation === 11 && bidder"
            class="tag is-danger tag-extended"
          >
            <h3 style="font-weight: bold">Não Aderido</h3>
          </div>

          <button
            class="button is-danger actions"
            v-if="displayRevokeItem(props.row.estado)"
            :disabled="disable.revokeItem"
            @click.prevent.stop="openModal(props.row.id, 'revoke-item')"
          >
            Revogar
          </button>
        </div>
      </b-table-column>

      <b-table-column
        class="options-column"
        centered
        label="Opções"
        v-slot="props"
        :visible="displayOptions"
      >
        <button
          class="button is-primary is-small is-outlined offers-button"
          v-if="displayOffersList(props.row) && !displayQualificationAnalysis"
          @click.prevent.stop="viewOffers(props.row)"
        >
          Ofertas
        </button>
        <button
          v-if="showUndoRowButton(props.row)"
          class="button is-danger is-small is-outlined offers-button"
          :class="{ 'is-loading': undoLoadingItemId === props.row.id }"
          :disabled="
            (loading.general && undoLoadingItemId !== props.row.id) ||
            !isUndoEligibleItem(props.row)
          "
          :title="!isUndoEligibleItem(props.row) ? 'Sem ações para desfazer' : ''"
          @click.prevent.stop="openUndoConfirmationForItem(props.row)"
        >
          Desfazer
        </button>
        <b-tooltip
          v-if="displayAppealIntentionButton"
          :label="appealIntentionButtonTooltip"
          size="is-small"
          position="is-left"
        >
          <button
            class="button is-small is-primary is-outlined offers-button"
            :class="{ 'is-loading': manifestAppealLoading }"
            :disabled="disableAppealIntentionButton"
            @click.prevent.stop="manifestAppealIntention"
          >
            {{ appealIntentionButtonText }}
          </button>
        </b-tooltip>
      </b-table-column>

      <template v-slot:detail="props">
        <QualificationAnalysis
          v-if="displayQualificationAnalysisRow(props.row)"
          :item="props.row"
          @undone="onQualificationUndone"
        />
      </template>

      <template v-slot:footer>
        <div class="columns">
          <div class="column has-text-left">
            <button
              v-if="displayMyItemsButton"
              class="button is-primary my-items-button"
              style="height: 100%"
              @click.stop.prevent="viewMyItems()"
            >
              Estou Participando
            </button>
          </div>
          <AppPagination
            class="column is-narrow"
            :has-margin="false"
            :data-filters="{
              page: pagination.page,
              perPage: pagination.perPage,
            }"
            :max-lines="50"
            :total="items.length"
            @change-page="page => changePage({ page })"
            @change-per-page="perPage => changePerPage(perPage)"
          />
        </div>
      </template>
    </b-table>

    <b-modal
      has-modal-card
      ref="justificationModal"
      :active.sync="justification"
      :onCancel="resetStateButtons"
      @justificate="sendJustification"
    >
      <AppJustification
        v-if="justification"
        :displayFailButton="displayFailButton"
        :displaySuccessButton="displaySuccessButton"
        :failText="failText"
        :successText="successText"
      />
    </b-modal>

    <b-modal
      has-modal-card
      :active.sync="displayConfirmation"
      :onCancel="resetStateButtons"
      @confirm="priceAdhesion"
    >
      <AppActionConfirmation
        v-if="displayConfirmation"
        :confirm-type="adhesionConfirmation.confirmType"
        :display="adhesionConfirmation.display"
        :iconType="adhesionConfirmation.iconType"
        :items="adhesionConfirmation.items"
        :message="adhesionConfirmation.message"
        :mobile="mobile"
      />
    </b-modal>

    <b-modal
      has-modal-card
      :active.sync="displayUndoConfirmation"
      :onCancel="resetUndoState"
      @confirm="confirmUndo"
    >
      <AppUndoConfirmation
        v-if="displayUndoConfirmation"
        :items="undoEligibleItems"
        :ineligible-items="undoIneligibleItems"
        :loading="loading.general"
        :mobile="mobile"
      />
    </b-modal>

    <b-modal has-modal-card :active.sync="displayRequestDiligenceModal">
      <JudgmentDiligenceRequestModal
        v-if="displayRequestDiligenceModal"
        :items="selectedJudgmentItems"
        :loading="loading.general"
        @close="displayRequestDiligenceModal = false"
        @submit="submitRequestDiligence"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import { formatarValor, formatarPorcentagem } from '@/utils/format';

import auctionItems from '@/mixins/auctionItems';

import AppPagination from '@/components/AppPagination';
import AppJustification from '@/components/AppJustification';
import AppActionConfirmation from '@/components/AppActionConfirmation';
import AppUndoConfirmation from '@/components/AppUndoConfirmation';
import SelecionarEmpresaAdesao from '@/views/Pregao/AuctionContainer/SelecionarEmpresaAdesao';
import JudgmentDiligenceRequestModal from '@/views/Pregao/AuctionContainer/JudgmentDiligence/JudgmentDiligenceRequestModal';
import QualificationAnalysis from '@/views/Pregao/AuctionContainer/Qualifications/QualificationAnalysis';
import { funcoes, SituacaoEnum } from '../../../../utils/enumerados';
import { podeExibirBotaoIntencaoRecurso } from '../../../../utils/intencaoRecursoVisibility';

export default {
  name: 'AllItems',
  props: ['closedBid', 'closedEligibleBidder', 'myItemsFilter', 'loaded'],
  components: {
    AppPagination,
    AppActionConfirmation,
    AppJustification,
    AppUndoConfirmation,
    SelecionarEmpresaAdesao,
    JudgmentDiligenceRequestModal,
    QualificationAnalysis,
  },
  mixins: [auctionItems],
  data() {
    const disable = {
      abdicateAdherence: false,
      accept: false,
      adhere: false,
      adjudicate: false,
      disqualify: false,
      homologate: false,
      qualify: false,
      refuse: false,
      revokeItem: false,
    };
    const pagination = {
      page: 1,
      perPage: 20,
    };

    return {
      action: '',
      adhesionData: {},
      adhesionConfirmation: {},
      bidItems: true,
      disable,
      displayConfirmation: false,
      displayUndoConfirmation: false,
      displayFailButton: false,
      displaySuccessButton: false,
      failText: '',
      formatarValor,
      formatarPorcentagem,
      SituacaoEnum,
      manifestAppealLoading: false,
      justification: false,
      itemId: null,
      rowAlias: null,
      selectedItems: [],
      successText: '',
      descriptionKey: 0,
      pagination,
      undoEligibleItems: [],
      undoIneligibleItems: [],
      undoPreview: null,
      undoLoadingItemId: null,
      undoEligibleItemIds: [],
      displayRequestDiligenceModal: false,
    };
  },
  computed: {
    ...mapState('app', ['windowWidth']),
    ...mapState('proposals', ['proposals']),
    ...mapState('auctionsQualifications', ['qualifications']),
    ...mapState('judgmentDiligences', ['diligences']),
    ...mapState('auctionsBidders', ['userLoggedBidder']),
    ...mapGetters('judgmentDiligences', {
      activeDiligenceForItemBidder: 'activeDiligenceForItemBidder',
    }),
    ...mapGetters({
      adhesions: 'obterAdesoesPregao',
      appeals: 'obterOfertaCompraRecursos',
      bids: 'obterOfertaCompraLances',
      items: 'obterTodosItens',
      hasAppealIntention: 'verificarOfertaCompraIntencaoRecursoManifestada',
      qualificationOpenedItemIds: 'obterQualificationOpenedItemIds',
      prazoManifestacaoIntencao: 'obterPrazoManifestacaoIntencao',
      responsaveis: 'obterOfertaCompraResponsaveis',
      currentUser: 'getUser',
    }),
    qualificationDetailsList: {
      get() {
        return this.qualificationOpenedItemIds.slice();
      },
      set(opened) {
        this.setQualificationOpenedItemIds(opened);
      },
    },
    refuseButtonLabel() {
      return this.auctionSituation === 19 ? 'Desclassificar' : 'Recusar';
    },
    filteredAcceptIds() {
      return this.selectedItems
        .filter(item => this.canBulkAcceptNegotiationItem(item))
        .map(item => item.id);
    },
    filteredRefuseIds() {
      return this.selectedItems
        .filter(item => this.canBulkRefuseNegotiationItem(item))
        .map(item => item.id);
    },
    filteredIds() {
      return this.selectedItems
        .filter(
          item =>
            this.canBulkAcceptNegotiationItem(item) || this.canBulkRefuseNegotiationItem(item),
        )
        .map(item => item.id);
    },
    itemsToShow() {
      return this.items.slice(
        (this.pagination.page - 1) * this.pagination.perPage,
        this.pagination.page * this.pagination.perPage,
      );
    },
    adheredBid() {
      return this.bids.some(lance => lance.adesao === 'ADERIDO');
    },
    closedFirstCall() {
      return this.items.some(
        item => ['PRIMEIRA-CHAMADA', 'LANCE-ENCERRADA'].indexOf(item.estado) > -1,
      );
    },
    closedNewCall() {
      return this.items.every(
        item =>
          [
            'NOVA-CHAMADA',
            'LANCE-ENCERRADA',
            'NEGOCIACAO-ENCERRADA',
            'JULGAMENTO-ENCERRADO',
            'HABILITACAO-ENCERRADA',
            'FRACASSADA',
            'DESERTO',
            'REVOGADO',
          ].indexOf(item.estado) > -1,
      );
    },
    displayActions() {
      if (this.displayQualificationAnalysis && this.authorizedBuyer && !this.adherenceStep) {
        return false;
      }

      if (
        [
          SituacaoEnum.EDITAL_PUBLICADO,
          SituacaoEnum.ENTREGA_DE_PROPOSTAS,
          SituacaoEnum.AGUARDANDO_INICIO_SESSAO,
        ].indexOf(this.auctionSituation) > -1 &&
        this.authority
      ) {
        return this.items.some(
          item => ['REVOGADO', 'FRACASSADA', 'DESERTO', 'HOMOLOGADO'].indexOf(item.estado) === -1,
        );
      }

      if (
        ((this.auctionSituation === SituacaoEnum.NEGOCIACAO ||
          this.auctionSituation === SituacaoEnum.JULGAMENTO ||
          this.auctionSituation === SituacaoEnum.HABILITACAO ||
          this.suspendedQualification) &&
          this.authorizedBuyer &&
          !this.adherenceStep) ||
        ((this.auctionSituation === SituacaoEnum.HABILITACAO || this.suspendedQualification) &&
          this.authorizedBuyer &&
          this.adherenceStep &&
          this.qualifyingItem) ||
        (this.auctionSituation === SituacaoEnum.HABILITACAO && this.bidder && this.adheredBid) ||
        (this.auctionSituation === SituacaoEnum.HABILITACAO &&
          this.bidder &&
          !!this.auction?.phase_inversion &&
          !this.adherenceStep &&
          this.qualifyingItem) ||
        (this.suspendedQualification && this.bidder && this.qualifyingItem)
      ) {
        return true;
      }

      if (
        this.auctionSituation === SituacaoEnum.ADESAO_DE_PRECO &&
        this.bidder &&
        this.bids.length
      ) {
        const itemsForAdherence = [];
        this.items.forEach(item => {
          this.bids.forEach(lance => {
            if (
              item.id === lance.ofertaCompraItemId &&
              ['PODEADERIR', 'ADERIDO', 'NAOADERIDO'].indexOf(lance.adesao) > -1 &&
              item.menor_lance.fornecedor_id !== this.userLoggedBidder.id &&
              item.estado === 'ADESAO'
            ) {
              itemsForAdherence.push(lance);
            }
          });
        });

        if (itemsForAdherence.length) return true;
      }

      return false;
    },
    displayCheckable() {
      return (
        this.displaySessaoAberta ||
        this.displayAdjudicateButton ||
        this.displayHomologateButton ||
        this.displayUndoButton
      );
    },
    displayUndoButton() {
      if (this.isPhaseInversionQualificationStage) {
        return false;
      }
      return this.canUndoInCurrentStage;
    },
    isPhaseInversionQualificationStage() {
      return !!this.auction?.phase_inversion && this.verifySituation(SituacaoEnum.HABILITACAO);
    },
    displayQualificationAnalysis() {
      return this.isPhaseInversionQualificationStage;
    },
    displayItemMeasureColumns() {
      return this.auctionSituation < SituacaoEnum.LANCES || this.displayQualificationAnalysis;
    },
    canUndoInCurrentStage() {
      if (!this.crier && !this.authority && !this.agenteContratacao) {
        return false;
      }

      return (
        this.verifySituation(SituacaoEnum.HABILITACAO) ||
        this.verifySituation(SituacaoEnum.JULGAMENTO)
      );
    },
    hasUndoEligibleItems() {
      return this.undoEligibleItemIds.length > 0;
    },
    hasActualAppeals() {
      if (this.auctionSituation === SituacaoEnum.ENCERRADA_COM_RECURSO) {
        return true;
      }
      return Array.isArray(this.appeals) && this.appeals.length > 0;
    },
    hasAdjudicationAuthorityRole() {
      const userId = this.currentUser && this.currentUser.id;
      if (!userId || !Array.isArray(this.responsaveis)) return this.authority;
      return this.responsaveis.some(
        responsavel =>
          responsavel.funcao === 'AUTORIDADE' && Number(responsavel.usuario_id) === Number(userId),
      );
    },
    displayAdjudicateButton() {
      const canConductSession = this.crier || this.agenteContratacao;
      if (!this.hasAdjudicationAuthorityRole && !canConductSession) return false;
      if (!this.hasAdjudicationAuthorityRole && this.hasActualAppeals) return false;
      if (
        [SituacaoEnum.ENCERRADA_COM_VENCEDOR, SituacaoEnum.ENCERRADA_COM_RECURSO].indexOf(
          this.auctionSituation,
        ) === -1
      ) {
        return false;
      }
      const phaseInversion = !!this.auction?.phase_inversion;
      const itensAdjudicar = this.items.some(item => {
        return (
          item.estado === 'HABILITACAO-ENCERRADA' ||
          (phaseInversion && item.estado === 'JULGAMENTO-ENCERRADO')
        );
      });
      return itensAdjudicar;
    },
    displayHomologateButton() {
      if (!this.authority) return false;
      if (
        [SituacaoEnum.ENCERRADA_COM_VENCEDOR, SituacaoEnum.ENCERRADA_COM_RECURSO].indexOf(
          this.auctionSituation,
        ) === -1
      ) {
        return false;
      }
      const itensHomologar = this.items.some(item => {
        return item.estado === 'ADJUDICADO';
      });
      return itensHomologar;
    },
    displaySessaoAberta() {
      return (
        [
          SituacaoEnum.ANALISANDO_PROPOSTAS,
          SituacaoEnum.LANCES,
          SituacaoEnum.PREFERENCIA,
          SituacaoEnum.NEGOCIACAO,
          SituacaoEnum.JULGAMENTO,
        ].indexOf(this.auctionSituation) > -1 && this.crier
      );
    },
    displayMinorBid() {
      if (this.displayQualificationAnalysis) {
        return false;
      }

      return (
        [
          SituacaoEnum.LANCES,
          SituacaoEnum.PREFERENCIA,
          SituacaoEnum.NEGOCIACAO,
          SituacaoEnum.HABILITACAO,
          SituacaoEnum.INTERPOSICAO_DE_RECURSOS,
          SituacaoEnum.MANIFESTACAO_INTENCAO_RECURSO,
          SituacaoEnum.ADESAO_DE_PRECO,
          SituacaoEnum.ENCERRADA_COM_VENCEDOR,
          SituacaoEnum.ENCERRADA_COM_RECURSO,
          SituacaoEnum.SUSPENSA,
          SituacaoEnum.JULGAMENTO,
        ].indexOf(this.auctionSituation) > -1
      );
    },
    displayMinorBidTag() {
      if (this.displayQualificationAnalysis) {
        return false;
      }

      return (
        [
          SituacaoEnum.LANCES,
          SituacaoEnum.PREFERENCIA,
          SituacaoEnum.NEGOCIACAO,
          SituacaoEnum.HABILITACAO,
          SituacaoEnum.INTERPOSICAO_DE_RECURSOS,
          SituacaoEnum.MANIFESTACAO_INTENCAO_RECURSO,
          SituacaoEnum.ADESAO_DE_PRECO,
          SituacaoEnum.ENCERRADA_COM_VENCEDOR,
          SituacaoEnum.ENCERRADA_COM_RECURSO,
          SituacaoEnum.SUSPENSA,
          SituacaoEnum.JULGAMENTO,
        ].indexOf(this.auctionSituation) > -1
      );
    },
    displayMyItemsButton() {
      if (
        this.auctionSituation === SituacaoEnum.LANCES &&
        this.bidder &&
        this.myItemsFilter &&
        this.closedBid &&
        this.closedEligibleBidder &&
        !this.adherenceStep
      ) {
        return true;
      }

      return (
        [
          SituacaoEnum.LANCES,
          SituacaoEnum.PREFERENCIA,
          SituacaoEnum.NEGOCIACAO,
          SituacaoEnum.HABILITACAO,
          SituacaoEnum.JULGAMENTO,
        ].indexOf(this.auctionSituation) > -1 &&
        this.bidder &&
        this.myItemsFilter &&
        !this.adherenceStep &&
        !this.closedBid
      );
    },
    displayOptions() {
      return (
        (this.auctionSituation > SituacaoEnum.AGUARDANDO_INICIO_SESSAO &&
          this.items.some(item => item.existe_proposta)) ||
        this.items.some(item => item?.menor_lance?.valor)
      );
    },
    displayStartBids() {
      return this.verifySituation(SituacaoEnum.LANCES) && this.crier;
    },
    displayTotalReferential() {
      return (
        this.authorizedBuyer &&
        this.negotiationType === 1 &&
        (this.displayQualificationAnalysis ||
          [
            SituacaoEnum.EDITAL_PUBLICADO,
            SituacaoEnum.ENTREGA_DE_PROPOSTAS,
            SituacaoEnum.AGUARDANDO_INICIO_SESSAO,
            SituacaoEnum.ANALISANDO_PROPOSTAS,
          ].indexOf(this.auctionSituation) > -1)
      );
    },
    itemsForBids() {
      return this.selectedItems.map(item => item.id);
    },
    qualifyingItem() {
      return this.items.some(item => item.estado === 'HABILITACAO');
    },
    agenteContratacao() {
      return (
        this.function === funcoes['AGENTE-CONTRATACAO'] ||
        this.function === funcoes['AGENTE-CONTRATACAO-SUBSTITUTO']
      );
    },
    suspendedQualification() {
      return (
        this.auctionSituation === SituacaoEnum.SUSPENSA &&
        this.deadlines &&
        this.deadlines[this.deadlines.length - 2]?.prazo_id === 11
      );
    },
    suspendedJudgment() {
      return (
        this.auctionSituation === SituacaoEnum.SUSPENSA &&
        this.deadlines &&
        this.deadlines[this.deadlines.length - 2]?.prazo_id === 19
      );
    },
    displayJudgmentDiligenceStage() {
      return this.verifySituation(SituacaoEnum.JULGAMENTO) || this.suspendedJudgment;
    },
    selectedJudgmentItems() {
      return this.selectedItems.filter(item => item.estado === 'JULGAMENTO');
    },
    canOpenBulkNegotiationModal() {
      return this.filteredAcceptIds.length > 0 || this.filteredRefuseIds.length > 0;
    },
    displayRequestDiligenceBulk() {
      return (this.crier || this.agenteContratacao) && this.displayJudgmentDiligenceStage;
    },
    displayAppealIntentionButton() {
      return podeExibirBotaoIntencaoRecurso({
        auction: this.auction,
        situacao: this.auctionSituation,
        prazoManifestacao: this.prazoManifestacaoIntencao,
        isBidder: this.bidder,
      });
    },
    appealIntentionButtonText() {
      return this.hasAppealIntention
        ? 'Intenção de recurso registrada'
        : 'Manifestar Intenção de Recurso';
    },
    appealIntentionButtonTooltip() {
      return this.hasAppealIntention
        ? 'Intenção de recurso registrada.'
        : 'Manifestar intenção de recurso.';
    },
    disableAppealIntentionButton() {
      return this.manifestAppealLoading || this.hasAppealIntention;
    },
    hasSelectedJudgmentDiligenceBlock() {
      return this.selectedItems.some(item => this.hasJudgmentDiligenceBlock(item));
    },
    selectedNegotiationTooltip() {
      if (!this.selectedItems.length || this.canOpenBulkNegotiationModal) {
        return '';
      }

      if (this.hasSelectedJudgmentDiligenceBlock) {
        return 'Aguardando análise dos documentos da diligência';
      }

      return '';
    },
  },
  watch: {
    auctionSituation(situation, previousSituation) {
      if (situation === SituacaoEnum.PREFERENCIA) this.selectedItems = [];
      this.fetchAppealIntention(previousSituation);
      this.scheduleUndoEligibilityRefresh();
      this.refreshJudgmentDiligences();
    },
    'auction.id': function watchAuctionId(id, previousId) {
      this.fetchAppealIntention();
      if (previousId && id !== previousId) {
        this.setQualificationOpenedItemIds([]);
      }
    },
    items: {
      handler(items) {
        if (Array.isArray(items)) {
          items.forEach(item => {
            if (item.referencia !== null) formatarValor(item.referencia);
          });
        } else if (items?.referencia !== null) {
          formatarValor(items.referencia);
        }

        this.scheduleUndoEligibilityRefresh();
      },
      deep: true,
    },
    loaded(isLoaded) {
      if (isLoaded) {
        this.verifyOverflowed();
        this.scheduleUndoEligibilityRefresh();
      }
    },
  },
  sockets: {
    'ofertacompra:adesoes': function atualizarOfertaCompraAdesoes(adesao) {
      if (this.buyer) this.adicionarAdesaoPregao(adesao);
    },
    'auction:judgment-diligences': function updateJudgmentDiligences(diligences) {
      this.updateJudgmentDiligences(diligences);
      this.refreshJudgmentDiligences();
    },
  },
  methods: {
    ...mapActions('judgmentDiligences', [
      'fetchJudgmentDiligences',
      'fetchUnresolvedJudgmentDiligences',
      'requestJudgmentDiligence',
      'updateJudgmentDiligences',
    ]),
    ...mapActions([
      'permitirLances',
      'permitirPreferencia',
      'aceitarLanceNegociacao',
      'recusarLanceNegociacao',
      'negotiationItemsSelected',
      'removerItem',
      'revogarItem',
      'adjudicarVencedorItens',
      'homologarVencedorItens',
      'inabilitarLicitante',
      'adicionarAdesaoPregao',
      'buscarOfertaCompraLances',
      'buscarOfertaCompraIntencaoRecurso',
      'sincronizarIntencaoRecursoPorSituacao',
      'manifestarOfertaCompraIntencaoRecurso',
      'previewUndoAuctionItems',
      'undoAuctionItems',
      'buscarAdesoesPregao',
      'setQualificationOpenedItemIds',
    ]),
    getFornecedorFormatado(lance) {
      if (!lance || !lance.fornecedor || !lance.razao_social) {
        return null;
      }

      return `(${lance.fornecedor}) ${lance.razao_social}`;
    },
    changePage({ page }) {
      this.pagination.page = page;
    },
    changePerPage(perPage) {
      this.pagination.page =
        Number(perPage) > Number(this.pagination.perPage) ? 1 : this.pagination.page;
      this.pagination.perPage = perPage;
    },
    abdicateAdhesionItem(itemId) {
      return this.bids.some(
        lance => lance.ofertaCompraItemId === itemId && lance.adesao === 'NAOADERIDO',
      );
    },
    disableAccept(data) {
      if (data?.item?.tipo === 'LOT') {
        const proposal = this.proposals?.find(
          p =>
            p.oferta_compra_item_id === data.id &&
            p.fornecedor_id === data.menor_lance?.fornecedor_id,
        );
        if (proposal) {
          return !(['NEGOCIACAO', 'JULGAMENTO'].includes(data?.estado) && proposal.readequada);
        }
      }
      return false;
    },
    acceptButtonTooltip(row) {
      if (this.hasJudgmentDiligenceBlock(row)) {
        return 'Aguardando análise dos documentos da diligência';
      }
      if (this.disableAccept(row)) {
        return 'Aguardando readequação de proposta pelo licitante';
      }
      return '';
    },
    hasJudgmentDiligenceBlock(row) {
      if (!this.displayJudgmentDiligenceStage || row.estado !== 'JULGAMENTO') {
        return false;
      }

      const diligence = this.getActiveDiligenceForRow(row);

      if (!diligence?.active || !diligence.documentsSent) {
        return false;
      }

      return diligence.hasPendingDocuments === true;
    },
    getActiveDiligenceForRow(row) {
      return this.activeDiligenceForItemBidder(row.id, row.menor_lance?.fornecedor_id);
    },
    displayReviewJudgmentDiligence(row) {
      if (!(this.crier || this.agenteContratacao) || !this.displayJudgmentDiligenceStage) {
        return false;
      }

      const diligence = this.getActiveDiligenceForRow(row);
      return !!diligence;
    },
    openJudgmentDiligenceReview(row) {
      const diligence = this.getActiveDiligenceForRow(row);
      if (!diligence) return;

      this.$emitBus('judgment-diligence-review', {
        item: row,
        diligence,
        company: {
          alias: row.menor_lance?.fornecedor,
          bidderId: row.menor_lance?.fornecedor_id,
          socialDenomination: row.menor_lance?.razao_social,
        },
      });
    },
    openRequestDiligenceModal() {
      if (!this.selectedJudgmentItems.length) {
        this.$alerta('Selecione itens em julgamento', 'is-danger');
        return;
      }
      this.displayRequestDiligenceModal = true;
    },
    async submitRequestDiligence(description) {
      this.loading.general = true;
      try {
        await this.requestJudgmentDiligence({
          auctionId: this.auction.id,
          itemIds: this.selectedJudgmentItems.map(item => item.id),
          description,
        });
        await this.refreshJudgmentDiligences();
        this.$alerta('Diligência solicitada com sucesso', 'is-success');
        this.displayRequestDiligenceModal = false;
        this.selectedItems = [];
      } catch (error) {
        const message = error?.response?.data?.details?.message || 'Erro ao solicitar diligência';
        this.$alerta(message, 'is-danger');
      }
      this.loading.general = false;
    },
    async refreshJudgmentDiligences() {
      if (!this.auction?.id || !this.displayJudgmentDiligenceStage) return;

      await Promise.all([
        this.fetchJudgmentDiligences({ auctionId: this.auction.id, activeOnly: true }),
        this.fetchUnresolvedJudgmentDiligences({ auctionId: this.auction.id }),
      ]);
    },
    async acceptOffer({ itemId, justificativa }) {
      const aceita = await this.aceitarLanceNegociacao({ itemId, justificativa });
      if (aceita) {
        this.$alerta('Proposta aceita', 'is-success');
        await this.refreshUndoEligibilityPreview();
      } else {
        this.$alerta('Erro ao aceitar proposta', 'is-danger');
      }
      this.disable.accept = false;
      this.disable.refuse = false;
      this.sendCloseModal();
    },
    async negotiationItems({ items, accept, justification }) {
      const success = await this.negotiationItemsSelected({ items, accept, justification });
      if (success) {
        const message = accept ? 'Propostas aceitas' : 'Propostas recusadas';
        const typeMessage = accept ? 'is-success' : 'is-danger';
        this.$alerta(message, typeMessage);
        await this.refreshUndoEligibilityPreview();
      } else {
        const message = accept ? 'Erro ao aceitar as propostas' : 'Erro ao recusar as propostas';
        this.$alerta(message, 'is-danger');
      }
      this.disable.accept = false;
      this.disable.refuse = false;
      this.selectedItems = [];
      this.sendCloseModal();
    },
    canBulkAcceptNegotiationItem(row) {
      return (
        this.displayAcceptRefuse(row?.estado, row) &&
        !this.disableAccept(row) &&
        !this.hasJudgmentDiligenceBlock(row)
      );
    },
    canBulkRefuseNegotiationItem(row) {
      return this.displayAcceptRefuse(row?.estado, row) && !this.hasJudgmentDiligenceBlock(row);
    },
    adheredPriceItem(itemId) {
      return this.bids.some(
        lance => lance.ofertaCompraItemId === itemId && lance.adesao === 'ADERIDO',
      );
    },
    async adjudicateItens(data) {
      try {
        await this.adjudicarVencedorItens(data);
        this.$alerta('Os vencedores foram adjudicados', 'is-success');
      } catch (error) {
        this.$alerta('Erro ao adjudicar os vencedores', 'is-danger');
      }
      this.selectedItems = [];
      this.disable.adjudicate = false;
      this.sendCloseModal();
    },
    async homologateItens(data) {
      try {
        await this.homologarVencedorItens(data);
        this.$alerta('Os vencedores foram homologado', 'is-success');
      } catch (error) {
        this.$alerta('Erro ao homologar os vencedores', 'is-danger');
      }
      this.selectedItems = [];
      this.disable.homologate = false;
      this.sendCloseModal();
    },
    canAdhereItem(itemId) {
      return this.bids.some(
        lance => lance.ofertaCompraItemId === itemId && lance.adesao === 'PODEADERIR',
      );
    },
    checkableItems(item) {
      if (item.estado === 'LANCE-ENCERRADA' && this.auction.modo_disputa === 'FECHADO') {
        return false;
      }

      if (
        this.auctionSituation === SituacaoEnum.LANCES &&
        !this.bidStarted &&
        ['CADASTRADA', 'LANCE-ENCERRADA', 'HABILITACAO-ENCERRADA'].indexOf(item.estado) > -1
      ) {
        return true;
      }

      if (
        this.auctionSituation === SituacaoEnum.LANCES &&
        !this.bidStarted &&
        ((item.estado === 'PRIMEIRA-CHAMADA' && this.closedFirstCall) ||
          (item.estado === 'NOVA-CHAMADA' && this.closedNewCall))
      ) {
        return true;
      }

      if (
        this.auctionSituation === SituacaoEnum.PREFERENCIA &&
        item.estado === 'PREFERENCIA' &&
        !this.preferenceStarted
      ) {
        return true;
      }

      if (this.auctionSituation === SituacaoEnum.NEGOCIACAO && item.estado === 'NEGOCIACAO') {
        return true;
      }

      if (this.auctionSituation === SituacaoEnum.JULGAMENTO && item.estado === 'JULGAMENTO') {
        return true;
      }

      if (this.isUndoEligibleItem(item)) {
        return true;
      }

      if (
        [SituacaoEnum.ENCERRADA_COM_VENCEDOR, SituacaoEnum.ENCERRADA_COM_RECURSO].indexOf(
          this.auctionSituation,
        ) > -1 &&
        (item.estado === 'HABILITACAO-ENCERRADA' || item.estado === 'JULGAMENTO-ENCERRADO')
      ) {
        return true;
      }

      if (
        [SituacaoEnum.ENCERRADA_COM_VENCEDOR, SituacaoEnum.ENCERRADA_COM_RECURSO].indexOf(
          this.auctionSituation,
        ) > -1 &&
        item.estado === 'ADJUDICADO'
      ) {
        return !this.items.some(
          it => it.estado === 'HABILITACAO-ENCERRADA' || it.estado === 'JULGAMENTO-ENCERRADO',
        );
      }

      return false;
    },
    async sendJustification({ justification, state }) {
      if (this.action === 'adjudicate') {
        await this.adjudicateItens({
          itens: this.selectedItems.map(item => item.id),
          justificativa: justification || 'Item adjudicado.',
        });
      } else if (this.action === 'homologate') {
        await this.homologateItens({
          itens: this.selectedItems.map(item => item.id),
          justificativa: justification || 'Item homologado.',
        });
      } else if (this.itemId) {
        if (this.action === 'accept') {
          await this.acceptOffer({
            itemId: this.itemId,
            justificativa: justification || 'Preço aceito.',
          });
        } else if (this.action === 'refuse') {
          await this.refuseOffer({
            itemId: this.itemId,
            justificativa: justification,
          });
        } else if (this.action === 'negotiation') {
          const items = state === 'success' ? this.filteredAcceptIds : this.filteredRefuseIds;
          if (!items.length) {
            this.$alerta(
              state === 'success'
                ? 'Nenhum item selecionado pode ser aceito.'
                : 'Nenhum item selecionado pode ser recusado.',
              'is-danger',
            );
            return;
          }
          await this.negotiationItems({
            items,
            accept: state === 'success',
            justification: justification || 'Preço aceito.',
          });
        } else if (this.action === 'disqualify') {
          await this.disqualifyBidder({
            itemId: this.itemId,
            fornecedor: this.rowAlias,
            justificativa: justification,
          });
        } else if (this.action === 'revoke-item') {
          await this.revokeAuctionItem({
            ofertaCompraItemId: this.itemId,
            justificativa: justification,
          });
        }
        this.itemId = null;
      }
      this.action = '';
    },
    adjudicarFornecedoresItens() {
      this.openModal(0, 'adjudicate');
    },
    homologarFornecedoresItens() {
      this.openModal(0, 'homologate');
    },
    displayAcceptRefuse(itemState, row) {
      // When returning to Judgment after a previous acceptance, keep
      // accept/refuse hidden until the decision is undone.
      if (itemState === 'JULGAMENTO' && this.hasAcceptedJudgmentForItem(row?.id)) {
        return false;
      }

      return (
        (itemState === 'NEGOCIACAO' && this.auctionSituation === SituacaoEnum.NEGOCIACAO) ||
        (itemState === 'JULGAMENTO' && this.displayJudgmentDiligenceStage)
      );
    },
    hasAcceptedJudgmentForItem(itemId) {
      if (!itemId) return false;

      return this.bids.some(bid => {
        const bidItemId =
          bid.ofertaCompraItemId || bid.oferta_compra_item_id || bid.itemId || bid.item_id;
        const sameItem = Number(bidItemId) === Number(itemId);
        const negotiated =
          bid.negociacao === true ||
          bid.negociacao === 't' ||
          bid.negociacao === 'true' ||
          bid.negociacao === 1 ||
          bid.negociacao === '1';

        return sameItem && negotiated;
      });
    },
    getItemStatusLabel(row) {
      const state = row?.estado;
      if (!state) return '-';

      const terminalStateLabels = {
        ANULADO: 'Anulado',
        DESERTO: 'Deserto',
        FRACASSADA: 'Fracassado',
        REVOGADO: 'Revogado',
      };
      if (terminalStateLabels[state]) {
        return terminalStateLabels[state];
      }

      const stageLabels = {
        ADESAO: 'Adesão',
        HABILITACAO: 'Habilitação',
        JULGAMENTO: 'Julgamento',
        'JULGAMENTO-ENCERRADO': 'Aceito',
        NEGOCIACAO: 'Negociação',
      };
      if (stageLabels[state]) {
        return stageLabels[state];
      }

      return this.$options.filters.tituloEstadoItem(state, this.auction.modo_disputa);
    },
    displayAdherenceButton(itemId, bidderId, itemState) {
      const disabledItem = this.qualifications.some(
        habilitacao => habilitacao.item_id === itemId && habilitacao.status === 'INABILITADA',
      );

      return (
        this.auctionSituation === SituacaoEnum.ADESAO_DE_PRECO &&
        this.bidder &&
        bidderId !== this.userLoggedBidder.id &&
        this.itemParticipant(itemId) &&
        !disabledItem &&
        this.canAdhereItem(itemId) &&
        itemState === 'ADESAO'
      );
    },
    displayRevokeItem(itemState) {
      return (
        this.authority &&
        [
          SituacaoEnum.EDITAL_PUBLICADO,
          SituacaoEnum.ENTREGA_DE_PROPOSTAS,
          SituacaoEnum.AGUARDANDO_INICIO_SESSAO,
          SituacaoEnum.ENCERRADA_COM_VENCEDOR,
          SituacaoEnum.ENCERRADA_COM_RECURSO,
          SituacaoEnum.SUSPENSA,
        ].indexOf(this.auctionSituation) > -1 &&
        ['REVOGADO', 'DESERTO', 'FRACASSADA'].indexOf(itemState) === -1
      );
    },
    displaySendDocuments(itemId, itemState) {
      // Habilitação NORMAL + inversão: qualquer participante do item.
      if (
        this.auction?.phase_inversion &&
        !this.adherenceStep &&
        this.bidder &&
        (this.auctionSituation === SituacaoEnum.HABILITACAO || this.suspendedQualification) &&
        itemState === 'HABILITACAO' &&
        this.itemParticipant(itemId)
      ) {
        return true;
      }

      // Habilitação da adesão (legado, tipicamente sem inversão): quem aderiu.
      if (
        this.adheredPriceItem(itemId) &&
        this.bidder &&
        this.auctionSituation === SituacaoEnum.HABILITACAO &&
        itemState === 'HABILITACAO'
      ) {
        return true;
      }

      if (this.bidder && this.suspendedQualification && itemState === 'HABILITACAO') {
        if (this.adherenceStep) {
          return this.adheredPriceItem(itemId);
        }

        const item = this.items.find(currentItem => currentItem.id === itemId);
        return !!item && item.menor_lance?.fornecedor === this.userLoggedBidder.alias;
      }

      return false;
    },
    displayViewDocuments(item) {
      if (
        ['FRACASSADA', 'DESERTO', 'REVOGADO', 'NEGOCIACAO', 'NOVA-CHAMADA'].indexOf(item.estado) >
        -1
      ) {
        return false;
      }

      return (
        (this.auctionSituation === SituacaoEnum.HABILITACAO || this.suspendedQualification) &&
        this.authorizedBuyer &&
        !this.adherenceStep &&
        ['HABILITACAO', 'HABILITACAO-ENCERRADA'].includes(item.estado)
      );
    },
    async disqualifyBidder(data) {
      try {
        await this.inabilitarLicitante(data);
        this.$alerta('Licitante inabilitado', 'is-danger');
        await this.refreshUndoEligibilityPreview();
      } catch (error) {
        this.$alerta('Erro ao inabilitar licitante', 'is-danger');
      }
      this.disable.disqualify = false;
      this.sendCloseModal();
    },
    itemParticipant(itemId) {
      return this.bids.some(lance => lance.ofertaCompraItemId === itemId);
    },
    mountAdhesionConfirmation(itemId, identifier, itemDescription, itemUnity, adhesion) {
      this.adhesionConfirmation.display = {
        identifier: true,
        description: true,
        unity: true,
        brand: false,
        imported: false,
        percent: false,
        value: false,
      };

      this.adhesionConfirmation.message = `Você ${
        adhesion ? 'está' : 'não está'
      } aderindo ao menor preço do Item:`;
      this.adhesionConfirmation.iconType = adhesion ? 'is-primary' : 'is-danger';
      this.adhesionConfirmation.confirmType = adhesion ? 'is-primary' : 'is-danger';

      this.adhesionConfirmation.items = [];
      this.adhesionConfirmation.items.push({
        identifier,
        description: itemDescription,
        unity: itemUnity,
        percent: null,
      });

      this.adhesionData = { itemId, identifier, adhesion };
      this.displayConfirmation = true;
    },
    openModal(itemId, action, fornecedor = '') {
      if (action === 'adjudicate') {
        this.disable.adjudicate = true;
        this.successText = 'Adjudicar';
        this.displaySuccessButton = true;
        this.displayFailButton = false;
      } else if (action === 'homologate') {
        this.disable.homologate = true;
        this.successText = 'Homologar';
        this.displaySuccessButton = true;
        this.displayFailButton = false;
      } else if (action === 'disqualify') {
        this.disable.disqualify = true;
        this.failText = 'Inabilitar';
        this.displaySuccessButton = false;
        this.displayFailButton = true;
      } else if (action === 'accept') {
        this.disable.accept = true;
        this.disable.refuse = true;
        this.displaySuccessButton = true;
        this.displayFailButton = false;
        this.successText = 'Aceitar';
      } else if (action === 'refuse') {
        this.disable.refuse = true;
        this.disable.accept = true;
        this.displayFailButton = true;
        this.failText = this.auctionSituation === 19 ? 'Desclassificar' : 'Recusar';
        this.displaySuccessButton = false;
      } else if (action === 'negotiation') {
        this.disable.refuse = true;
        this.disable.accept = true;
        this.displaySuccessButton = this.filteredAcceptIds.length > 0;
        this.displayFailButton = this.filteredRefuseIds.length > 0;
        this.successText = 'Aceitar';
        this.failText = this.auctionSituation === 19 ? 'Desclassificar' : 'Recusar';
      } else if (action === 'revoke-item') {
        this.disable.revokeItem = true;
        this.failText = 'Revogar';
        this.displaySuccessButton = false;
        this.displayFailButton = true;
      }

      this.itemId = itemId;
      this.rowAlias = fornecedor;
      this.action = action;
      this.justification = true;
    },
    async priceAdhesion() {
      this.disable.adhere = true;
      this.disable.abdicateAdherence = true;
      try {
        await this.adesaoMenorPrecoItem({
          itemId: this.adhesionData.itemId,
          aderido: this.adhesionData.adhesion,
        });
        this.$alerta(
          `${this.biggestDiscount ? 'Maior desconto' : 'Menor preço'} ${
            this.adhesionData.adhesion ? 'aderido' : 'não aderido'
          } no Item ${this.adhesionData.identifier}`,
          `${this.adhesionData.adhesion ? 'is-success' : 'is-danger'}`,
        );
      } catch (error) {
        if (
          error.response &&
          error.response.status === 400 &&
          error.response.data.error.type === 'AuctionAdhesionClockFinished'
        ) {
          this.$alerta('Tempo finalizado', 'is-danger');
          return;
        }

        this.$alerta(
          `Erro ao ${this.adhesionData.adhesion ? 'aderir' : 'não aderir'} o ${
            this.biggestDiscount ? 'maior desconto' : 'menor preço'
          } do item`,
          'is-danger',
        );
      }
      this.disable.adhere = false;
      this.disable.abdicateAdherence = false;
    },
    async refuseOffer({ itemId, justificativa }) {
      const refused = await this.recusarLanceNegociacao({ itemId, justificativa });
      if (refused) {
        this.$alerta('Proposta recusada', 'is-danger');
        await this.refreshUndoEligibilityPreview();
      } else {
        this.$alerta('Erro ao recusar proposta', 'is-danger');
      }
      this.disable.refuse = false;
      this.disable.accept = false;
      this.sendCloseModal();
    },
    resetStateButtons() {
      this.loading.general = false;
      this.loading.documents = false;
      this.disable.accept = false;
      this.disable.refuse = false;
      this.disable.disqualify = false;
      this.disable.revokeItem = false;
      this.disable.adjudicate = false;
      this.disable.homologate = false;
    },
    async revokeAuctionItem(data) {
      try {
        await this.revogarItem(data);
        this.$alerta('O item foi revogado', 'is-success');
      } catch (error) {
        this.$alerta('Erro ao revogar item', 'is-danger');
      }
      this.disable.revokeItem = false;
      this.sendCloseModal();
    },
    async selectCompany(item, company) {
      this.loading.documents = true;
      await Promise.all([
        this.fetchRequiredDocuments(this.auction.id),
        this.fetchAuctionBidderDocuments({
          auctionId: this.auction.id,
          bidderId: company.bidderId,
          itemId: item.id,
        }),
      ]);
      await this.$emitBus('documentos', { item, company });
      this.loading.documents = false;
    },
    sendCloseModal() {
      this.$refs.justificationModal.close();
    },
    async startBids() {
      this.loading.general = true;
      this.bidItems = await this.permitirLances(this.itemsForBids);
      if (this.bidItems) {
        if (this.selectedItems.length === 1) {
          this.$alerta('Item iniciado para lance', 'is-success');
        } else if (this.selectedItems.length > 1) {
          this.$alerta('Itens iniciados para lances', 'is-success');
        }
        this.selectedItems = [];
      } else {
        this.$alerta('Erro ao iniciar lances', 'is-danger');
      }
      this.loading.general = false;
    },
    async startPreference() {
      this.loading.general = true;
      this.bidItems = await this.permitirPreferencia(this.itemsForBids);
      if (this.bidItems) {
        if (this.selectedItems.length === 1) {
          this.$alerta('Item aberto para preferência', 'is-success');
        } else if (this.selectedItems.length > 1) {
          this.$alerta('Itens abertos para preferência', 'is-success');
        }
        this.selectedItems = [];
      } else {
        this.$alerta('Erro ao iniciar lances', 'is-danger');
      }
      this.loading.general = false;
    },

    totalAdhesions(itemId) {
      const adhesionsItem = this.adhesions
        ? this.adhesions.filter(elemento => elemento.itemId === itemId)
        : [];
      return adhesionsItem.length;
    },
    totalProposals(itemId) {
      const propostasItem = this.proposals.filter(
        elemento => elemento.oferta_compra_item_id === itemId,
      );
      return propostasItem.length;
    },
    verifyItems() {
      this.bidItems = this.items.some(item =>
        ['LANCE', 'PREFERENCIA-INICIADA'].includes(item.estado),
      );
    },
    async viewCompanyDocuments(item) {
      const company = {
        alias: item.menor_lance?.fornecedor,
        bidderId: item.menor_lance?.fornecedor_id,
        socialDenomination: item.menor_lance?.razao_social,
      };
      await Promise.all([
        this.fetchRequiredDocuments(this.auction.id),
        this.fetchAuctionBidderDocuments({
          auctionId: this.auction.id,
          bidderId: company.bidderId,
          itemId: item.id,
        }),
      ]);
      this.$emitBus('documentos', { item, company });
    },
    viewMyItems() {
      this.$emit('view-my-items');
    },
    async fetchAppealIntention(situacaoAnterior) {
      if (!this.auction.id || !this.bidder) {
        return;
      }
      try {
        await this.sincronizarIntencaoRecursoPorSituacao({
          situacaoAnterior,
          situacaoAtual: this.auctionSituation,
          ofertaCompraId: this.auction.id,
        });
      } catch (error) {
        this.$alerta(error.message, 'is-danger');
      }
    },
    async manifestAppealIntention() {
      if (this.hasAppealIntention) {
        return;
      }
      this.manifestAppealLoading = true;
      try {
        await this.manifestarOfertaCompraIntencaoRecurso();
        this.$alerta('Intenção de recurso manifestada com sucesso', 'is-success');
      } catch (error) {
        this.$alerta(error.message, 'is-danger');
      } finally {
        this.manifestAppealLoading = false;
      }
    },
    verifySituation(auctionSituation) {
      return this.auction.situacao.id === auctionSituation;
    },
    resetUndoState() {
      this.undoEligibleItems = [];
      this.undoIneligibleItems = [];
      this.undoPreview = null;
      this.undoLoadingItemId = null;
    },
    scheduleUndoEligibilityRefresh() {
      if (this._undoEligibilityRefreshTimer) {
        clearTimeout(this._undoEligibilityRefreshTimer);
      }

      this._undoEligibilityRefreshTimer = setTimeout(() => {
        this.refreshUndoEligibilityPreview();
      }, 300);
    },
    async refreshUndoEligibilityPreview() {
      if (
        !this.canUndoInCurrentStage ||
        !this.items.length ||
        this.isPhaseInversionQualificationStage
      ) {
        this.undoEligibleItemIds = [];
        return;
      }

      try {
        const itemIds = this.items.map(item => item.id);
        const preview = await this.previewUndoAuctionItems(itemIds);
        this.undoEligibleItemIds = preview.eligible.map(item => item.itemId);
      } catch (error) {
        this.undoEligibleItemIds = [];
      }
    },
    isUndoEligibleItem(item) {
      return this.canUndoInCurrentStage && this.undoEligibleItemIds.includes(item.id);
    },
    showUndoRowButton(item) {
      if (this.isPhaseInversionQualificationStage) {
        return false;
      }

      if (!this.canUndoInCurrentStage) {
        return false;
      }

      return this.isRelevantUndoItemState(item);
    },
    displayQualificationAnalysisRow(item) {
      return (
        this.displayQualificationAnalysis &&
        ['HABILITACAO', 'HABILITACAO-ENCERRADA'].includes(item?.estado)
      );
    },
    onQualificationUndone() {
      this.scheduleUndoEligibilityRefresh();
    },
    isRelevantUndoItemState(item) {
      const state = item?.estado;
      return [
        'HABILITACAO',
        'HABILITACAO-ENCERRADA',
        'JULGAMENTO',
        'JULGAMENTO-ENCERRADO',
        'FRACASSADA',
        'NEGOCIACAO',
        'NOVA-CHAMADA',
      ].includes(state);
    },
    mapUndoItem(previewItem) {
      const item = this.items.find(row => row.id === previewItem.itemId);

      return {
        itemId: previewItem.itemId,
        identifier: previewItem.identifier,
        description: item?.item?.descricao || '',
        reason: previewItem.reason,
        actionLabel: previewItem.actionLabel || '',
        bidderAlias: previewItem.bidderAlias || '',
        bidderSocialDenomination: previewItem.bidderSocialDenomination || '',
        cascadeActions: (previewItem.cascadeActions || []).map(cascade => ({
          ...cascade,
          bidderAlias: cascade.bidderAlias || previewItem.bidderAlias || '',
          bidderSocialDenomination:
            cascade.bidderSocialDenomination || previewItem.bidderSocialDenomination || '',
        })),
      };
    },
    async openUndoConfirmationForItem(row) {
      if (!this.isUndoEligibleItem(row)) {
        return;
      }
      await this.openUndoConfirmation([row.id]);
    },
    async openUndoConfirmation(itemIds = null) {
      const normalizedItemIds = Array.isArray(itemIds) ? itemIds : null;
      const ids = normalizedItemIds ?? this.selectedItems.map(item => item.id);
      if (!ids.length) {
        return;
      }

      const isSingleItem = normalizedItemIds !== null;
      if (isSingleItem) {
        const [itemId] = ids;
        this.undoLoadingItemId = itemId;
      } else {
        this.loading.general = true;
      }

      try {
        const preview = await this.previewUndoAuctionItems(ids);

        if (!preview.eligible.length) {
          const firstReason = preview.ineligible.find(item => item?.reason)?.reason;
          const fallbackMessage = isSingleItem
            ? 'Este item não é elegível para desfazer'
            : 'Nenhum item selecionado é elegível para desfazer';

          this.$alerta(
            firstReason ? `${fallbackMessage}: ${firstReason}` : fallbackMessage,
            'is-warning',
          );
          return;
        }

        this.undoPreview = preview;
        this.undoEligibleItems = preview.eligible.map(item => this.mapUndoItem(item));
        this.undoIneligibleItems = preview.ineligible.map(item => this.mapUndoItem(item));
        this.displayUndoConfirmation = true;
      } catch (error) {
        this.$alerta('Erro ao desfazer ação', 'is-danger');
      } finally {
        if (isSingleItem) {
          this.undoLoadingItemId = null;
        } else {
          this.loading.general = false;
        }
      }
    },
    async confirmUndo({ justificativa }) {
      this.loading.general = true;

      try {
        const itemIds = this.undoPreview.eligible.map(item => item.itemId);
        await this.undoAuctionItems({ itemIds, justificativa });
        await Promise.all([
          this.buscarOfertaCompraLances({
            ofertaCompraId: this.auction.id,
            tipo: this.bidder ? 'empresa' : 'todas',
          }),
          this.buyer ? this.buscarAdesoesPregao() : Promise.resolve(),
        ]);
        this.$alerta('Ação desfeita com sucesso', 'is-success');
        this.selectedItems = [];
        this.resetUndoState();
        this.displayUndoConfirmation = false;
        await this.refreshUndoEligibilityPreview();
      } catch (error) {
        this.$alerta('Erro ao desfazer ação', 'is-danger');
      } finally {
        this.loading.general = false;
      }
    },
  },
  mounted() {
    this.$onBus('onTerminar:itensEmLance', () => {
      this.bidItems = false;
    });
    this.verifyItems();
    this.fetchAppealIntention();
    this.scheduleUndoEligibilityRefresh();
    this.refreshJudgmentDiligences();
    this.$nextTick(() => {
      this.verifyOverflowed();
    });
  },
  beforeDestroy() {
    if (this._undoEligibilityRefreshTimer) {
      clearTimeout(this._undoEligibilityRefreshTimer);
    }
  },
};
</script>

<style lang="scss" scoped>
.blink-button {
  &:not(hover) {
    -webkit-animation: blink 2s infinite both;
    animation: blink 2s infinite both;
  }

  &:hover {
    -webkit-animation: none;
    animation: none;
  }
}

@-webkit-keyframes blink {
  0%,
  50%,
  100% {
    background-color: #2153b5;
  }
  25%,
  75% {
    background-color: #568259;
  }
}
@keyframes blink {
  0%,
  50%,
  100% {
    background-color: #2153b5;
  }
  25%,
  75% {
    background-color: #568259;
  }
}

.my-items-button {
  margin-top: 0.6rem;
}
</style>

<style lang="scss">
.custom-eye-icon .mdi-eye-outline::before {
  font-size: 22px;
}

.auction-items-table .table-wrapper .table {
  max-width: 99.8%;
}

@media (min-width: 769px) {
  .elipsis-size {
    max-width: 1px;
    width: 100%;
  }
}
</style>

<style src="@/styles/items.scss" lang="scss" scoped />
